<app-loading-generico [loadingGenerico]="loadingGenerico"></app-loading-generico>
<app-header></app-header>
<app-botao-chat></app-botao-chat>


<div class="container py-4">
    <!-- CONTEÚDO -->
    <div class="row">
        <div class="col-lg-8 mb-4 mb-lg-0 mt-5">
            <div class="card">
              <app-breadcrumb></app-breadcrumb>
              <h1 class="titulo">Contratação de Rota Inteligente</h1>
                <p class="paragrafo mb-4 mt-2">Acesso aos planos de roteirização</p>

                <div class="row ms-1">
                <div class="text-center mb-5 mt-3">
                    <button type="button " class="btn-borda-verde bnt-font btn-grande" id="btnPlanoMensal" routerLink='/contratacao-plano-mensal'>PLANO MENSAL</button>
                    <button type="button " class="btn-borda-verde bnt-font btn-grande ms-5" id="btnPlanoAvulso" routerLink='/contratacao-plano-avulso'>PLANO AVULSO</button>
                </div>
            </div>
            </div>
        </div>
        <!-- DIV LATERAL COM AS DICAS E INFORMAÇÕES E DOWNLOAD DE ARQUIVOS, apenas algo estático -->
        <div class="col-lg-4">
            <div class="mt-5">
                <img class="d-none d-lg-block mb-4 rounded" src="/assets/img/banner_rc.jpg" width="100%" alt="Propaganda">
            </div>
        </div>
    </div>
</div>


<app-footer></app-footer>
